import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileDetails } from 'src/app/product-capture/import-product/import-product.consts';
import { DOCUMENT_STATE } from 'src/app/product-capture/model/consts/document-modal.consts';
import { DOCUMENT_TYPE } from 'src/app/product-capture/model/consts/document-type.const';
import { LANGUAGE_LIST } from 'src/app/product-capture/model/consts/language-list.const';
import { DcAlertService } from 'src/app/ui-kit/dc-alert/dc-alert.service';

@Component({
  selector: 'app-upload-modal',
  templateUrl: './upload-modal.component.html',
  styleUrls: ['./upload-modal.component.scss'],
})
export class UploadModalComponent implements OnInit {
  form: UntypedFormGroup;
  languages = LANGUAGE_LIST;
  types = DOCUMENT_TYPE;
  documentStateItems = DOCUMENT_STATE;

  constructor(
    public modal: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private dcAlertService: DcAlertService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      type: [null, Validators.required],
      language: [null, Validators.required],
      documentState: [DOCUMENT_STATE[0].id, Validators.required],
      file: [null, Validators.required],
    });
  }

  cancel(): void {
    this.modal.close('cancel');
  }

  save(): void {
    if (this.form.valid) {
      this.modal.close(this.form.value);
    } else {
      this.dcAlertService.showAlert({
        type: 'danger',
        message: `All fields are required.`,
      });
    }
  }

  handleFile(file: FileDetails): void {
    this.form.get('file').setValue({ file: file.file });
    file.progress = file.file.size;
  }
}
